import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { EquipmentInventory } from "../../../features/FloorManager/typings/svg.types";

export function useRemoteFetchEquipmentInventory() {
  return useRemoteQuery<EquipmentInventory[]>({
    queryKey: "equipment-inventory",
    url: "/equipment-inventory"
  });
}
